import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Select,
  Text,
} from "@chakra-ui/react";
import { MapViewModel } from "../api/ManagerApi";
import { useState } from "react";

enum MapViewSelectType {
  Bounds,
  Center,
}

interface Props {
  view: MapViewModel;
  updateView: (newView: MapViewModel) => void;
}

export const MapViewOptions = ({ view, updateView }: Props) => {
  const [viewSelectType, setViewSelectType] = useState<MapViewSelectType>(
    view.bounds ? MapViewSelectType.Bounds : MapViewSelectType.Center
  );

  return (
    <Box p={2}>
      <Box>
        <Select
          value={viewSelectType}
          onChange={(e) => setViewSelectType(+e.target.value as MapViewSelectType)}
        >
          <option key={MapViewSelectType.Bounds} value={MapViewSelectType.Bounds}>
            Gebied
          </option>
          <option key={MapViewSelectType.Center} value={MapViewSelectType.Center}>
            Middelpunt
          </option>
        </Select>
      </Box>
      {viewSelectType === MapViewSelectType.Bounds && (
        <>
          <Box>
            <Flex gap={2}>
              <FormControl variant="floating" flex={2}>
                <FormLabel>
                  <Text fontSize="md">Noord</Text>
                </FormLabel>
                <NumberInput
                  defaultValue={view.bounds?.north || 0}
                  onChange={(vas, van) =>
                    updateView({
                      ...view,
                      bounds: {
                        north: van || 0,
                        east: view.bounds?.east ?? 0,
                        south: view.bounds?.south ?? 0,
                        west: view.bounds?.west ?? 0,
                      },
                      center: null,
                    })
                  }
                >
                  <NumberInputField />
                </NumberInput>
              </FormControl>
              <FormControl variant="floating" flex={2}>
                <FormLabel>
                  <Text fontSize="md">Oost</Text>
                </FormLabel>
                <NumberInput
                  defaultValue={view.bounds?.east || 0}
                  onChange={(vas, van) =>
                    updateView({
                      ...view,
                      bounds: {
                        north: view.bounds?.north ?? 0,
                        east: van || 0,
                        south: view.bounds?.south ?? 0,
                        west: view.bounds?.west ?? 0,
                      },
                      center: null,
                    })
                  }
                >
                  <NumberInputField />
                </NumberInput>
              </FormControl>
            </Flex>
          </Box>
          <Box>
            <Flex gap={2}>
              <FormControl variant="floating" flex={2}>
                <FormLabel>
                  <Text fontSize="md">Zuid</Text>
                </FormLabel>
                <NumberInput
                  defaultValue={view.bounds?.south || 0}
                  onChange={(vas, van) =>
                    updateView({
                      ...view,
                      bounds: {
                        north: view.bounds?.north ?? 0,
                        east: view.bounds?.east ?? 0,
                        south: van || 0,
                        west: view.bounds?.west ?? 0,
                      },
                      center: null,
                    })
                  }
                >
                  <NumberInputField />
                </NumberInput>
              </FormControl>
              <FormControl variant="floating" flex={2}>
                <FormLabel>
                  <Text fontSize="md">West</Text>
                </FormLabel>
                <NumberInput
                  defaultValue={view.bounds?.west || 0}
                  onChange={(vas, van) =>
                    updateView({
                      ...view,
                      bounds: {
                        north: view.bounds?.north ?? 0,
                        east: view.bounds?.east ?? 0,
                        south: view.bounds?.south ?? 0,
                        west: van || 0,
                      },
                      center: null,
                    })
                  }
                >
                  <NumberInputField />
                </NumberInput>
              </FormControl>
            </Flex>
          </Box>
        </>
      )}
      {viewSelectType === MapViewSelectType.Center && (
        <Flex gap={2}>
          <FormControl variant="floating" flex={2}>
            <FormLabel>
              <Text fontSize="md">Latitude</Text>
            </FormLabel>
            <NumberInput
              defaultValue={view.center?.latitude || 0}
              onChange={(vas, van) =>
                updateView({
                  ...view,
                  bounds: null,
                  center: {
                    latitude: van || 0,
                    longitude: view.center?.longitude ?? 0,
                  },
                })
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl variant="floating" flex={2}>
            <FormLabel>
              <Text fontSize="md">Longitude</Text>
            </FormLabel>
            <NumberInput
              defaultValue={view.center?.longitude || 0}
              onChange={(vas, van) =>
                updateView({
                  ...view,
                  bounds: null,
                  center: {
                    latitude: view.center?.latitude ?? 0,
                    longitude: van || 0,
                  },
                })
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
        </Flex>
      )}
    </Box>
  );
};
